import shimadaImage from '../file/farmer/drsfarm-shimada.webp';
import morishitaImage from '../file/farmer/drsfarm-morishita.jpg';
import miyawakiImage from '../file/farmer/drsfarm-miyawaki.jpg';
import nishijimaImage from '../file/farmer/drsfarm-nishijima.jpg';
import aokiImage from '../file/farmer/drsfarm-aoki.jpg';
import hukamiImage from '../file/farmer/drsfarm-hukami.jpg';
import hatchHouseImage from '../file/farmer/drsfarm-hacchiHouse.webp';
import ofukuroImage from '../file/farmer/drsfarm-ohukurofarm.webp';
import placeholderFarmerImage from '../file/farmer/画像なし農家.jpeg';
import dvegeSofixPdf from '../file/sofix/【Dvege】SOFIX 20241106.pdf';
import dvegeSofixPage1 from '../file/sofix/【Dvege】SOFIX20241106_ページ_1.jpg';
import dvegeSofixPage2 from '../file/sofix/【Dvege】SOFIX20241106_ページ_2.jpg';
import shimadaSofixPdf from '../file/sofix/【嶋田】SOFIX 20240418.pdf';
import shimadaSofixPage1 from '../file/sofix/【嶋田】SOFIX20240418_ページ_1.jpg';
import shimadaSofixPage2 from '../file/sofix/【嶋田】SOFIX20240418_ページ_2.jpg';
import nenohiraSofixPdf from '../file/sofix/【ねのひら】SOFIX20251107.pdf';
import nenohiraSofixPage1 from '../file/sofix/【ねのひら】SOFIX20251107_ページ_1.jpg';
import nenohiraSofixPage2 from '../file/sofix/【ねのひら】SOFIX20251107_ページ_2.jpg';
import macoaraSofixPdf from '../file/sofix/【まこあら】SOFIX20260308.pdf';
import macoaraSofixPage1 from '../file/sofix/【まこあら】SOFIX20260308_ページ_1.jpg';
import macoaraSofixPage2 from '../file/sofix/【まこあら】SOFIX20260308_ページ_2.jpg';

export const featuredFarmers = [
  {
    id: 'aoki-nenohira',
    slug: 'nenohira-monogatari',
    name: 'ねのひら物語',
    ownerName: '青木國楯',
    prefecture: '三重県',
    city: '三重郡菰野町',
    farmerType: 'fulltime',
    crops: [],
    heroImageUrl: aokiImage,
    youtubeUrl: 'https://youtu.be/xUiCneaV5hc',
    instagramUrl: 'https://www.instagram.com/nenohirawuyu/',
    websiteUrl: 'https://www.nenohiramonogatari.jp/',
    contactLabel: 'メール',
    contactUrl: 'mailto:k.aoki1771@gmail.com',
    contactText: 'E-mail: k.aoki1771@gmail.com / TEL: 090-3567-3790',
    fieldAddress: '三重県三重郡菰野町根の平5番地14',
    geo: { lat: 35.0687065, lng: 136.4820475 },
    mapUrl: 'https://www.google.com/maps/place/%E3%80%92510-1327+%E4%B8%89%E9%87%8D%E7%9C%8C%E4%B8%89%E9%87%8D%E9%83%A1%E8%8F%B0%E9%87%8E%E7%94%BA%E6%A0%B9%E3%81%AE%E5%B9%B3%EF%BC%95%E2%88%92%EF%BC%91%EF%BC%94/@35.0687037,136.4821182,3a,75y,272.83h,90t/data=!3m7!1e1!3m5!1staGof4WCFrU2cZZhywBbBw!2e0!6shttps:%2F%2Fstreetviewpixels-pa.googleapis.com%2Fv1%2Fthumbnail%3Fcb_client%3Dmaps_sv.tactile%26w%3D900%26h%3D600%26pitch%3D0%26panoid%3DtaGof4WCFrU2cZZhywBbBw%26yaw%3D272.83438!7i16384!8i8192!4m15!1m8!3m7!1s0x6003eaf6d74ae0c5:0xa34e0b7ca54cf5b2!2z44CSNTEwLTEzMjcg5LiJ6YeN55yM5LiJ6YeN6YOh6I-w6YeO55S65qC544Gu5bmz77yV4oiS77yR77yU!3b1!8m2!3d35.0687065!4d136.4820475!16s%2Fg%2F11g8q3xsyg!3m5!1s0x6003eaf6d74ae0c5:0xa34e0b7ca54cf5b2!8m2!3d35.0687065!4d136.4820475!16s%2Fg%2F11g8q3xsyg?entry=ttu&g_ep=EgoyMDI2MDQyMi4wIKXMDSoASAFQAw%3D%3D',
    environmentText: '三重県三重郡菰野町根の平にある圃場です。鈴鹿山脈に近い自然環境の中で、山あいの地形や水の流れを感じられるエリアです。',
    description: '2009年6月に農業を開始し、身体にやさしい野菜の生産・販売と農業の担い手育成に取り組んでいます。',
    story: [
      '2009年6月に農業を開始しました。',
      '「多くの方に健康な身体で暮らしていただきたい」という思いから、身体にやさしい野菜の生産・販売、そして農業の担い手育成に取り組んでいます。',
      '約4,000坪の畑からスタートし、現在は17年目を迎えました。',
      '農薬・化学肥料を使わないのはもちろん、硝酸態窒素を抑えた野菜づくりにも力を入れています。',
      'これまでに6名の担い手が育ち、そのうち3名が農業で自立しています。',
      '現在は2名の研修生が、将来の独立を目指して日々努力しています。',
    ].join('\n'),
    philosophyText: [
      '大切にしているのは、土と種です。',
      '私たちの野菜づくりは、土の呼吸を助けることから始まります。',
      '土壌生物が心地よく生きられる環境を整え、太陽・水・空気といった自然の力を最大限に活かします。',
      '草の根に集まる根粒菌の働きによって微生物が活発になり、その微生物たちが土を耕し、野菜がよく育つ豊かな土壌を育てていきます。',
      'こうしたダイナミックな自然循環の中で、私たちの「食」は生まれています。',
      'また、毎年受け継ぐ種は、その土地の微生物や気候風土に適応し、より強い生命力を宿していきます。',
      '実りをもたらしてくれた野菜に敬意を払い、種を採り、命のバトンを次の世代へとつないでいきます。',
    ].join('\n'),
    soilBuildingText: [
      '私たちは、一般的な意味での「土づくり」に過度に手を加えません。',
      'できる限り自然の循環に委ねることを大切にしています。',
      '栽培は、葉物野菜から始まり、根菜類、果菜類へと順に育てていきます。',
      '一巡した後に野菜由来の堆肥を施し、この流れを繰り返すことで、土壌を循環させながら生産を行っています。',
      'およそ2回転した後には太陽熱消毒を行い、土の状態を整えます。',
      'また、土を深く耕すことは極力控え、自然の力を活かした耕作を続けています。',
    ].join('\n'),
  },
  {
    id: 'macoara-farm',
    slug: 'macoara-farm',
    name: 'まこあらファーム',
    ownerName: '深見由佳梨',
    prefecture: '愛知県',
    city: '瀬戸市上半田川町',
    farmerType: 'parttime',
    crops: ['真菰'],
    heroImageUrl: hukamiImage,
    youtubeUrl: 'https://youtu.be/NjWYIPA5xkE',
    instagramUrl: 'https://www.instagram.com/macoara_farm/',
    websiteUrl: 'https://macoara-farm.com/',
    reservationUrl: 'https://reserva.be/macoara',
    fieldAddress: '愛知県瀬戸市上半田川町',
    geo: { lat: 35.2696212, lng: 137.1580265 },
    mapUrl: 'https://maps.app.goo.gl/cc3soz2mSsgcBZpcA',
    environmentText: '山あいの棚田に蛇ヶ洞川の清流を引き入れて栽培しています。周辺の里山、水辺、生き物の気配まで含めて圃場環境を見られます。',
    description: '愛知県瀬戸市で、清流を引き入れた棚田にて、栽培期間中無肥料・無農薬で真菰を育てています。',
    story: [
      'はじめまして！愛知県瀬戸市で真菰（まこも）の栽培をしている、まこあらファームです。',
      '瀬戸市上半田川町の山あいにある棚田の1番上で、オオサンショウウオや蛍が棲息する蛇ヶ洞川の清流を引き入れて、栽培期間中無肥料・無農薬で真菰を育てています。',
      '真菰はおよそ1億年前から地球に存在するイネ科の薬草です。古事記・日本書紀にも登場し、2mを越すその大きな葉は古くからしめ縄やご神事の道具の材料に使われてきました。',
      'まこあらファームでは、真菰の不思議な生態から豊富な栄養、興味深い神話・伝承などさまざまな魅力を発信しながら、まこも茶やしめ縄アクセサリーなどの真菰商品を販売しています。',
    ].join('\n'),
    philosophyText: [
      'まこあらファームは農薬や化学肥料を使わずに、自然栽培で真菰を育てています。',
      '瀬戸市上半田川町の豊かな自然の中で、冷涼な川水と澄んだ空気、時折訪れる野生動物やさまざまな虫たちと調和しながら、のびのびと真菰たちは成長しています。"ありのまま"がまこあらファームのモットーです。',
      'その自然の美しさと気持ち良さ、土に触れる楽しさと真菰の生態の面白さを直接肌で感じていただくために、まこあらファームは農業体験イベントを定期的に開催しています。',
    ].join('\n'),
    soilBuildingText: [
      '春先に耕運を数回行い、代掻きと苗植え後は過剰に田んぼに手を加えません。',
      '田んぼ内の土だけでなく、畔にも農薬や化学肥料は使いません。',
      'たくさんのオタマジャクシが田んぼを泳ぎまわり、カモやシラサギ、鵜などが田んぼに頻繁に遊びに来ます。',
      '多種多様な生命と共生しながら真菰たちは育っています。',
    ].join('\n'),
  },
  {
    id: 'hatch-house',
    slug: 'hatch-house',
    name: 'ハッチハウス',
    ownerName: '高橋正幸・光子',
    prefecture: '愛知県',
    city: '春日井市桃山町周辺',
    farmerType: 'parttime',
    crops: ['果物', '野菜'],
    heroImageUrl: hatchHouseImage,
    youtubeUrl: 'https://youtu.be/IZZUNdV5-8A',
    instagramHandle: 'okashikoubou_tsumugi',
    instagramUrl: 'https://www.instagram.com/okashikoubou_tsumugi/',
    fieldAddress: '愛知県春日井市桃山町周辺',
    geo: { lat: 35.2831793, lng: 136.9730525 },
    mapUrl: 'https://maps.app.goo.gl/mKmu8Zi9xLXX1cui7',
    environmentText: '春日井市と小牧市にまたがる丘陵地で、果樹や野菜の栽培と日本ミツバチの保護活動を行っています。',
    description: '春日井市・小牧市にまたがる丘陵地で、日本ミツバチの保護活動を行いながら、果物や野菜を栽培しています。',
    story: [
      '現在、春日井市・小牧市にまたがる丘陵地にて、日本ミツバチの保護活動を行いながら、桃・プラム・柑橘類などの果物や野菜を栽培しています。',
      'もともとは会社勤めをしておりましたが、40代の頃から連休を利用して草刈りや土づくりに取り組んできました。その結果、30年以上にわたり化学的なものに頼らない環境で栽培を続けています。野菜や果物が美味しいのは、その積み重ねによるものだと感じています。',
      '約20年前、日本ミツバチの蜂蜜をいただいた際、そのあまりの美味しさに感動し、飼育を始めました。その後、日本ミツバチが減少している現状を知り、保護活動にも力を入れるようになりました。',
      '現在はボランティアとして小牧市にも登録しており、日本ミツバチに関するご相談やお困りごとがあれば対応しています。お気軽にご連絡ください。',
    ].join('\n'),
    philosophyText: '自然に優しく・身体にも優しい食の安全安心を目指した農園を運営し、またこの方針に興味のある方がハッチハウスに集い、楽しい一時を過ごせる場所を提供する。',
    soilBuildingText: [
      'オーガニック農法の認定は、とれていませんが30年以上取り組んでいます。',
      'そのため大量のミミズやテントウムシが住み着いています。',
      'また果物の木の下で日本ミツバチが活動しているのを見ていただけます。',
    ].join('\n'),
  },
  {
    id: 'ofukuro-farm',
    slug: 'ofukuro-farm',
    name: 'おふくろ農園',
    ownerName: '小澤浩之',
    prefecture: '愛知県',
    city: '弥富市楽平周辺',
    farmerType: 'parttime',
    crops: ['米', '野菜'],
    heroImageUrl: ofukuroImage,
    youtubeUrl: 'https://youtu.be/3C00DsgAfOc',
    fieldAddress: '愛知県弥富市楽平周辺',
    contactLabel: 'メール',
    contactUrl: 'mailto:h.ozawa@jyunyukai.jp',
    contactText: 'h.ozawa@jyunyukai.jp\n社会福祉法人淳湧界　小澤浩之',
    geo: { lat: 35.1250257, lng: 136.7541302 },
    mapUrl: 'https://maps.app.goo.gl/VWAWhVzj4sXtPgzK6',
    environmentText: '弥富市の田園地帯で、地域の福祉拠点とつながりながら米や野菜づくりに取り組んでいます。',
    description: '木村式自然栽培を取り入れ、微生物と自然の力を活かしてお米や野菜づくりに取り組んでいます。',
    story: [
      '「奇跡のリンゴ」で知られる木村秋則氏の木村式自然栽培を取り入れ、お米や野菜づくりに取り組んでいる「おふくろ農園」です。',
      '私たちは、「あいち診療所おふくろ」や「特別養護老人ホームおふくろの家」を運営する社会福祉法人淳湧界の中で、自然栽培の部署として立ち上がりました。',
      '現在は、廣和仁氏のご指導のもと、田んぼや畑の運営を行っています。',
      '将来的には、障がいのある方の雇用を創出し、自然農による就労継続支援B型事業所の運営も目指しています。',
      '自然の力を大切にしながら、人と地域にやさしい農業を続けてまいります。どうぞよろしくお願いいたします。',
    ].join('\n'),
    philosophyText: '農薬、肥料、有機肥料も使わない、微生物と自然の力で野菜やお米を栽培しています。',
    soilBuildingText: '',
  },
  {
    id: 'nishijima-yasumasa',
    slug: 'chihayafurusa-shizen-noen',
    name: 'ちはやふるさと自然農園',
    ownerName: '西島康雅',
    prefecture: '大阪府',
    city: '千早赤阪村',
    farmerType: 'parttime',
    crops: ['米', '野菜'],
    heroImageUrl: nishijimaImage,
    youtubeUrl: 'https://www.youtube.com/watch?v=0lpdnXJ6aic',
    instagramUrl: 'https://www.instagram.com/chihaya_furusato_natural_farm_/',
    fieldAddress: '大阪府千早赤阪村',
    geo: { lat: 34.4718421, lng: 135.6261288 },
    mapUrl: 'https://maps.app.goo.gl/vGAY6eqvjdnMoDM96',
    environmentText: '大阪府唯一の村である千早赤阪村の山里で、自然農による稲作と体験の場づくりを進めています。',
    description: '2024年から千早赤阪村で本格的に自然農による稲作に取り組み、食と健康を見つめ直す場づくりも進めています。',
    story: [
      '2022年より自然農に取り組み始めました。（野菜栽培が中心で、陸稲は残念ながら失敗）',
      'その後、2023年の暮れにご縁をいただき、大阪で唯一の村である千早赤阪村にて、2024年から本格的に自然農による稲作に取り組んでいます。',
      'これまで20年にわたり健康関連商品の販売に携わる中で、現代人の心身の不調には「食」の影響が大きく関わっていることを感じてきました。特にコロナ禍での体験を通じ、その重要性を改めて強く実感しています。',
      '健康に生きるためには、まず食の在り方を見直すこと。そして、農作業を通じて土に触れ、体を動かすことも大切だと考えています。そうした想いから、田植えや稲刈りなどを体験できる機会づくりにも取り組んでいます。',
      '自然とともにある暮らしの大切さを、多くの方と分かち合っていけたら嬉しく思います。どうぞよろしくお願いいたします。',
    ].join('\n'),
    philosophyText: '自然農、大自然のエネルギーを活かす。',
    soilBuildingText: 'その土地のものを循環させることを意識しています。',
  },
  {
    id: 'miyawaki-masanao',
    slug: 'dvege-miyawaki',
    name: 'Dvege',
    ownerName: '宮脇正尚',
    title: 'Dvege 宮脇正尚さん',
    prefecture: '愛知県',
    city: '江南市',
    farmerType: 'fulltime',
    crops: ['季節野菜'],
    heroImageUrl: miyawakiImage,
    youtubeUrl: 'https://www.youtube.com/watch?v=d7J7w5-bENE',
    websiteUrl: 'https://dvege2020.wixsite.com/website',
    fieldAddress: '愛知県江南市般若町中山周辺',
    geo: { lat: 35.3648611, lng: 136.8871111 },
    mapUrl: 'https://maps.app.goo.gl/18qsjD5tzmE62axr5',
    environmentText: '木曽川流域に近い江南市北部の農地エリアです。航空写真では、畑や田畑、集落、堤防沿いの緑地が近くに広がることを確認できます。地域の草を堆肥化して畑へ戻すDvegeの循環型の野菜づくりを、周辺環境ごと見える形で伝えます。',
    description: '2020年に江南市で新規就農し、環境に配慮した栽培で「一番おいしい」と思える野菜を厳選して育てています。',
    story: [
      'はじめまして、Dvege 宮脇正尚です。',
      '2020年に、江南市で新規就農をしました。小規模ですが、環境に配慮した野菜栽培で僕たちが食べて一番おいしい！と思う野菜を厳選しています。',
      '野菜は採れたて、そして旬のものが一番おいしい。それは僕の実体験からそう感じています。',
      '僕はもともと野菜全般が好きではありませんでした。あまり好きではない野菜の美味しさに気が付いたら、作ってみたくてしょうがなくなったからだと思います。',
      'そう思わせてくれたのが新鮮な野菜でした。自分のように野菜嫌いの人でも「美味しい！」と言わせるのが目標です。',
    ].join('\n'),
    philosophyText: [
      'Dvegeでは、農薬や化学肥料に頼らず、',
      '野菜本来の力と土の力を活かした栽培を行っています。',
      '',
      '野菜は本来育つべき“旬”の時期に育てることで、無理なく育ち、病気にも強くなります。',
      '旬の野菜はおいしく、季節の変わり目の身体に不足しがちな栄養がたっぷり。旬の採れたて野菜を食べれば滋養もとれます。日本の四季を感じていただくためにその時期に収穫できる野菜を作ります。',
      '',
      'ゆっくりと育った野菜は、しっかりとした味わいと力強さを感じます。',
      'そんな野菜が僕は美味しいと感じ、野菜嫌いの人でも美味しいと思える野菜を届けたいと思っています。',
    ].join('\n'),
    soilBuildingText: [
      '地域の資源として堤防等ででた草を堆肥化したものを畑に返して野菜を栽培しています。また、休耕畑では緑肥を栽培して刈り、土にすきこむ事で畑に有機物を補給しています。',
      '除草剤や化学肥料を使わず、地域の中で循環する農業を目指しています。',
    ].join('\n'),
  },
  {
    id: 'morishita-ikuma',
    slug: 'mabataki-farm-morishita',
    name: '株式会社MABATAKI Farm',
    ownerName: '森下生真',
    title: '株式会社MABATAKI Farm',
    prefecture: '長野県',
    city: '長和町大門地区、長久保地区',
    farmerType: 'parttime',
    crops: ['米'],
    heroImageUrl: morishitaImage,
    youtubeUrl: 'https://www.youtube.com/watch?v=cTo7jARFGyw',
    websiteUrl: 'https://mabatakifarm.com/owner/',
    fieldAddress: '長野県長和町大門地区、長久保地区',
    geo: { lat: 36.2325556, lng: 138.2531944 },
    mapUrl: 'https://maps.app.goo.gl/ZQbcu7UrsNmEJSdy6',
    environmentText: '長和町の大門地区、長久保地区を中心に、山間地の水田環境で米づくりに取り組んでいます。',
    description: '本業で愛知県の自動車関連会社を経営しながら、農業法人マバタキファームを立ち上げ、「安心・安全」だけでなく「美味しい」米づくりに励んでいます。',
    story: [
      '本業は愛知県で自動車関連の「ウエラ名古屋」を経営していますが、3年ほど前から中小企業が日本の農業を応援できないかと考え農業法人マバタキファームを立ち上げました。',
      '主に日本の主食である米作りをしていますが、栽培2年目で全国無農薬米コンテストで「金賞」を受賞しました。',
      'たくさんの方の応援で少しづつ栽培面積を増やし、初年度4反（0.4ha）だった田んぼも2026年度は2町(2ha)に増えます。',
      'これからも「安心・安全」だけでなく「美味しい」お米を目指して愛情たっぷりで米作りに励みます。',
    ].join('\n'),
    philosophyText: [
      'マバタキファームの哲学は「地球に優しい、生き物に優しい、そして人にも優しい」です。',
      'そして、すべては「瞬き」をするがごとく一瞬一瞬の積み重ねです。',
      'なので瞬間瞬間の選択がすべての物に優しくなれるようにを目指しています。',
    ].join('\n'),
    soilBuildingText: [
      'マバタキファームの田んぼでは、微生物が働き易い環境を整えることで理想の土づくりができると考えています。なので米ぬかぼかしや微生物資材を用いて微生物を活性化させています。',
      '今後の取り組みとしては研究機関と連携して「縄文の微生物再生プロジェクト」を立ち上げる予定です。これは、長和町が15,000年前の縄文時代に黒耀石の産地として日本のメッカだったことや、縄文土器などが多数発見されていることにちなんで、当時の微生物の研究や慣行農法で大幅に減少した微生物たちがどのように再生していくかを科学的に解明し、現代の農業へと応用していく取り組みです。',
      '具体的には、土壌中の微生物の種類やバランスの変化を分析し、自然農法によってどのように多様性が回復していくのかを可視化していきます。',
    ].join('\n'),
  },
  {
    id: 'shimada-yukihiro',
    slug: 'scubeorigin-shirao-shimada-farm',
    name: 'S³ Origin / しらおシマダファーム',
    ownerName: '嶋田幸洋',
    prefecture: '岐阜県',
    city: '郡上市白鳥町',
    farmerType: 'fulltime',
    crops: ['季節野菜'],
    heroImageUrl: shimadaImage,
    youtubeUrl: 'https://www.youtube.com/watch?v=XMX3KOx51jM',
    instagramHandle: 'scubeorigin',
    instagramUrl: 'https://www.instagram.com/scubeorigin?igsh=amFyMW9nZmgxaDEz&utm_source=qr',
    fieldAddress: '岐阜県郡上市白鳥町',
    geo: { lat: 35.8698542, lng: 136.8773951 },
    mapCamera: { tilt: 38, heading: 0, range: 360, altitude: 70 },
    mapUrl: 'https://maps.app.goo.gl/Ep8Qa26jCu8q55qS6',
    environmentText: '郡上市白鳥町の山あいにある圃場で、水と空気が抜ける土の構造を重視した栽培を行っています。',
    description: '岐阜で農園を営み、土の構造を整え、その変化を観察することを仕事にしています。',
    story: [
      '岐阜で農園を営んでいる、嶋田です。',
      '私は、作物を育てているというよりも、',
      '土の構造を整え、その変化を観察することを仕事にしています。',
      '水がどこを通り、空気がどこに入り、根がどこまで届くのか。',
      'その構造が整えば、作物は自然と健やかに育っていきます。',
      '本来、とてもシンプルなものです。',
      'ただ、その前提となる構造が見えにくくなっているだけだと感じています。',
      '現在は圃場運営と並行して、',
      '農をこれから始める方や、うまくいかずに悩んでいる方に向けて、',
      '教室やコンサルティングも行っています。',
      '特別な技術を教えるというよりも、',
      'まずは“どう見ればよいのか”を一緒に整えていくことを大切にしています。',
    ].join('\n'),
    philosophyText: [
      '私の哲学？は「構造から考える農業」です。',
      '土壌は、単なる物質ではなく、',
      '水・空気・微生物が動き続ける“構造体”です。',
      'その流れが成立しているかどうかで、',
      '作物の健全性も、収量も、大きく変わります。',
      'まず構造を整える。',
      'すると、自然と結果がついてくる。',
      'その積み重ねの中で、',
      '「人が無理に何かをする必要はない」という考えに至りました。',
      '一方で、初めて土に触れる方にとっては、',
      'その“構造”自体が見えないものでもあります。',
      'だからこそ私は、難しい言葉や理論よりも、',
      '現場で実際に見て、触れて、感じることを大切にしています。',
      '思想は後から生まれるものであり、',
      'すべては現場の構造から導かれるものだと考えています。',
    ].join('\n'),
    soilBuildingText: [
      '土づくりにおいて最も大切にしているのは、',
      '水と空気が滞らない構造をつくることです。',
      '表面だけではなく、30cmより深い層まで、',
      '水が抜け、空気が入り続ける状態を保つことで、',
      '微生物と根が無理なく働ける環境が整います。',
      '私は、何かを加えることよりも、',
      '過不足なく“流れを保つこと”を重視しています。',
      'だから何も加えません。',
      '土も作物も、とても正直です。',
      '無理をさせなければ、きちんと応えてくれます。',
      '初めての方にも、この変化は必ず感じていただけます。',
      'だからこそ、難しく考えすぎず、まずは土に触れてみてほしいと思っています。',
      '人ができることは多くありません。',
      'ただ、その環境にそっと寄り添い、整えること。',
      'それが私の土づくりです。',
    ].join('\n'),
  },
];

export function mergeFeaturedFarmers(remoteRows = []) {
  const remoteByKey = new Map();
  for (const row of remoteRows) {
    const key = row.slug || row.id;
    remoteByKey.set(key, row);
  }

  const merged = [];
  const usedKeys = new Set();

  for (const base of featuredFarmers) {
    const key = base.slug || base.id;
    const remote = remoteByKey.get(key);
    merged.push({ ...base, ...(remote || {}) });
    usedKeys.add(key);
  }

  for (const row of remoteRows) {
    const key = row.slug || row.id;
    if (usedKeys.has(key)) continue;
    merged.push(row);
  }

  return merged.sort((a, b) => String(a.name || '').localeCompare(String(b.name || '')));
}

export function getFeaturedFarmerBySlug(slug) {
  return featuredFarmers.find((row) => row.slug === slug || row.id === slug) || null;
}

function createDefaultSofixOverlayGuide(pageImages = []) {
  if (pageImages.length < 2) return null;

  return {
    title: 'SOFIXの見方',
    intro: 'STEPを押すか、右側を読み進めると、今見てほしい場所にオーバーレイが切り替わります。',
    steps: [
      {
        id: 'overview',
        pageIndex: 1,
        title: 'まずは評価の全体像を見る',
        body: '最初に見るのは、検査日と総合的な評価です。この1枚で、今回の土壌がどんな状態に近いのかを大まかにつかみます。',
        spotlight: { x: 0.03, y: 0.04, w: 0.94, h: 0.92, radius: 24, zoom: 1.02 },
      },
      {
        id: 'bacteria',
        pageIndex: 0,
        title: '次に総細菌数を見る',
        body: '総微生物量（総細菌数）は、細菌数は土の活性度を見るための指標です。まずここで、土の土台がどれくらい動いているかを見ます。',
        zoom: 1.84,
        spotlight: { x: 0, y: 0.288, w: 0.744, h: 0.1, radius: 18, zoom: 1.9 },
      },
      {
        id: 'nitrogen',
        pageIndex: 0,
        title: '窒素循環は、肥料を使える形へ変える力',
        body: '有機物がアンモニア、亜硝酸、硝酸へ変わる流れが保たれているかを見る項目です。肥料の量ではなく、土の働きを見ています。',
        zoom: 1.6,
        spotlights: [
          { x: 0.027, y: 0.313, w: 0.704, h: 0.142, radius: 22 },
        ],
      },
      {
        id: 'phosphorus',
        pageIndex: 0,
        title: 'リン循環は、リンを動かす力を見る',
        body: 'リンが土の中で使われやすい形へ変わる力を見る項目です。数値があっても、動く力が弱いと活きにくくなります。',
        zoom: 1.8,
        spotlights: [
          { x: 0, y: 0.365, w: 0.747, h: 0.072, radius: 22 },
        ],
      },
      {
        id: 'biomass',
        pageIndex: 0,
        title: '土壌バイオマス量で、有機物の土台を見る',
        body: 'TC・TN・C/Nは、微生物のえさになる有機物の量とバランスを見るための項目です。土の働きが続きやすい土台かをここで確認します。',
        zoom: 1.63,
        spotlight: { x: 0, y: 0.343, w: 0.747, h: 0.221, radius: 22, zoom: 1.52 },
      },
      {
        id: 'ph-ec',
        pageIndex: 0,
        title: '最後にpHやECで、環境の偏りを確認する',
        body: '土の酸性・アルカリ性や電気伝導度も合わせて見ます。微生物や作物にとって、極端に偏った環境になっていないかを確認します。',
        zoom: 1.64,
        captionPosition: 'top',
        spotlight: { x: 0.034, y: 0.609, w: 0.678, h: 0.211, radius: 22, zoom: 1.64 },
      },
    ],
    pages: pageImages.map((image, index) => ({
      id: `page-${index + 1}`,
      image,
      label: `検査結果 ${index + 1}ページ目`,
    })),
  };
}

const featuredFarmerSoilTests = {
  'dvege-miyawaki': [
    {
      id: 'sofix-dvege-2024-11-06',
      date: '2024-11-06',
      sampleLocation: 'Dvege 圃場',
      labName: 'SOFIX',
      notes: 'SOFIXによる土壌分析。評価A④。',
      pdfUrl: dvegeSofixPdf,
      overlayGuide: createDefaultSofixOverlayGuide([
        dvegeSofixPage1,
        dvegeSofixPage2,
      ]),
      metrics: {
        pH: 6.7,
        EC: 0.04,
        N: 1478,
        P: 741,
        K: 4328,
      },
    },
  ],
  'scubeorigin-shirao-shimada-farm': [
    {
      id: 'sofix-shimada-2024-04-18',
      date: '2024-04-18',
      sampleLocation: 'しらおシマダファーム 圃場',
      labName: 'SOFIX',
      notes: 'SOFIXによる土壌分析。評価A③。',
      pdfUrl: shimadaSofixPdf,
      overlayGuide: createDefaultSofixOverlayGuide([
        shimadaSofixPage1,
        shimadaSofixPage2,
      ]),
      metrics: {
        pH: 6.0,
        EC: 0.1,
        N: 3316,
        P: 2732,
        K: 5776,
      },
    },
  ],
  'nenohira-monogatari': [
    {
      id: 'sofix-nenohira-2025-11-07',
      date: '2025-11-07',
      sampleLocation: 'ねのひら物語 圃場',
      labName: 'SOFIX',
      notes: 'SOFIXによる土壌分析。評価A④。',
      pdfUrl: nenohiraSofixPdf,
      overlayGuide: createDefaultSofixOverlayGuide([
        nenohiraSofixPage1,
        nenohiraSofixPage2,
      ]),
      metrics: {
        pH: 7.0,
        EC: 0.28,
        N: 1792,
        P: 2101,
        K: 3846,
      },
    },
  ],
  'macoara-farm': [
    {
      id: 'sofix-macoara-2026-03-08',
      date: '2026-03-08',
      sampleLocation: 'まこあらファーム 圃場',
      labName: 'SOFIX',
      notes: 'SOFIXによる土壌分析。評価A⑤。',
      pdfUrl: macoaraSofixPdf,
      overlayGuide: createDefaultSofixOverlayGuide([
        macoaraSofixPage1,
        macoaraSofixPage2,
      ]),
      metrics: {
        pH: 6.7,
        EC: 0.04,
        N: 1716,
        P: 812,
        K: 3378,
      },
    },
  ],
};

export function getFeaturedFarmerSoilTestsBySlug(slugOrSlugs) {
  const keys = Array.isArray(slugOrSlugs) ? slugOrSlugs : [slugOrSlugs];
  for (const key of keys.filter(Boolean)) {
    const tests = featuredFarmerSoilTests[key];
    if (tests?.length) return tests;
  }
  return [];
}

export function mergeFeaturedFarmerSoilTests(slugOrSlugs, remoteRows = []) {
  const localRows = getFeaturedFarmerSoilTestsBySlug(slugOrSlugs);
  const merged = [...remoteRows];
  const seen = new Set(remoteRows.map((row) => row.id || `${row.date}-${row.labName || ''}`));

  for (const row of localRows) {
    const key = row.id || `${row.date}-${row.labName || ''}`;
    if (seen.has(key)) continue;
    merged.push(row);
  }

  return merged.sort((a, b) => String(a.date || '').localeCompare(String(b.date || '')));
}
